export default "__VITE_ASSET__be373bcd__"